<template>
  <div
    class="public-asset pdf-asset basic_style_asset file-asset-preview"
    v-if="fileAsset"
    :class="{ horizontal: horizontal }"
  >
    <ReportHeader
      v-if="showReportHeader"
      :account="account"
      :contentAsset="fileAsset"
      :backUrl="backUrl"
      :backText="backText"
    ></ReportHeader>

    <div class="wrapper" :class="{ 'no-footer': !showReportHeader }">
      <div class="header" v-if="!showReportHeader">
        <div class="asset-type">
          <i :class="assetIcon" />
          <h6>{{ assetLabel }}</h6>
        </div>
      </div>
      <h2 v-if="fileAsset.title">{{ fileAsset.title }}</h2>
      <div v-if="fileAsset.description" class="description">{{ fileAsset.description }}</div>

      <div class="media-wrapper mt-3">
        <MediaViewer v-if="fileAsset" :file-asset="fileAsset" :show-controls="true" />
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import ReportHeader from './basic_asset_parts/reports/ReportHeader.vue'
import MediaViewer from '@components/MediaViewer.vue'

export default {
  components: {
    ReportHeader,
    MediaViewer,
  },
  data() {
    return {
      localBlobUrl: null,
    }
  },
  props: {
    account: {
      type: Object,
      required: true,
    },
    fileAsset: {
      type: Object,
      required: true,
    },
    horizontal: {
      type: Boolean,
      default: false,
    },
    showReportHeader: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    backUrl() {
      return this.$cookies.get('site-back-url') && this.$cookies.get('site-back-url').length > 5
        ? this.$cookies.get('site-back-url')
        : `/user-research-library/${this.account.slug}`
    },
    backText() {
      return this.$cookies.get('site-back-text') && this.$cookies.get('site-back-text').length > 5
        ? this.$cookies.get('site-back-text')
        : `${this.account.name} Home`
    },
    assetIcon() {
      const contentType = this.fileAsset?.content_type
      if (contentType === 'image') return 'bi bi-image'
      if (contentType === 'pdf') return 'bi bi-file-richtext-fill'
      return 'bi bi-file-earmark' // fallback for unknown types
    },
    assetLabel() {
      const contentType = this.fileAsset?.content_type
      if (contentType === 'pdf') return 'PDF Asset'
      return 'Media Asset' // fallback for unknown types
    },
  },
}
</script>
<style lang="sass" scoped>

.pdf-asset
  .iframe-wrapper
    height: 100vh

.file-asset-preview
  .description
    color: rgba(108, 116, 125, 1)
    font-weight: 400
    font-size: 0.875em

  .media-wrapper
    width: 100%

  // When used without ReportHeader (similar to SocialPost)
  .wrapper
    &.no-footer
      .media-wrapper
        min-height: 400px
</style>
